module.exports = __webpack_public_path__ + "static/media/Team 3 Plastic hears studios logo.d364f8db.JPG";